import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOSchema from '@/components/feature/SEOSchema';
import HeroSection from './components/HeroSection';
import FeaturedComics from './components/FeaturedComics';
import CategoryPreview from './components/CategoryPreview';
import RankingSection from './components/RankingSection';
import LatestUpdates from './components/LatestUpdates';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <SEOSchema type="WebSite" />
      <SEOSchema type="Organization" />
      <SEOSchema
        type="WebPage"
        data={{
          name: '韩漫漫画网站 - 首页',
          description: '韩漫漫画网站致力于提供完整韩漫大全、优质推荐和流行排行榜，您可免费下拉式阅读高清内容，无广告干扰，享受纯粹阅读乐趣。',
          url: 'https://www.hanmancomic.com/',
          isPartOf: {
            '@type': 'WebSite',
            name: '韩漫漫画网站',
            url: 'https://www.hanmancomic.com',
          },
        }}
      />

      <Navbar />

      <main>
        <article>
          <HeroSection />
          <FeaturedComics />
          <CategoryPreview />
          <RankingSection />
          <LatestUpdates />
          <CTASection />
        </article>
      </main>

      <Footer />
    </>
  );
}